import { inject } from 'mobx-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { DisplayAd } from 'constants/ads';
import { InfositePageName, SearchPageName } from 'constants/pages';
import { PackageType } from 'models/multi-item/multi-item-types';

import { MesoDisplayAd } from './meso-display-ad';

interface MesoFooterProps {
  pageName: string;
}

@withLocalization
@inject('context')
export class MesoFooter extends React.Component<MesoFooterProps & LocalizedComponentProps> {
  public render() {
    const { pageName } = this.props;

    return Object.values(SearchPageName).some(val => val === pageName) ? <HSRFooter /> : <HISFooter pageName={pageName} />;
  }
}

interface FooterProps {
  pageName?: string;
}

const HSRFooter: React.FunctionComponent<FooterProps> = () => (
  <ErrorBoundary label="meso.footer">
    <div className="uitk-grid all-grid-align-center all-t-padding-six">
      <section className="uitk-grid all-grid-align-center">
        <MesoDisplayAd {...DisplayAd.FOOTER_CM1} />
        <MesoDisplayAd {...DisplayAd.FOOTER_CM2} />
        <MesoDisplayAd {...DisplayAd.FOOTER_CM3} />
      </section>
    </div>
  </ErrorBoundary>
);

const isPackagePath = (pageName: string): boolean =>
  Object.values(PackageType).some((packageName: string) => InfositePageName[packageName] === pageName);

const HISFooter: React.FunctionComponent<FooterProps> = ({ pageName }) => (
  <ErrorBoundary label="meso.footer">
    <div className="uitk-grid all-grid-align-center all-y-padding-four all-cell-1-1">
      <div className="uitk-cell all-cell-1-1 all-b-padding-four">
        <section className="uitk-grid all-grid-align-center">
          <MesoDisplayAd {...DisplayAd.FOOTER_CM1} />
          <MesoDisplayAd {...DisplayAd.FOOTER_CM2} />
          <MesoDisplayAd {...DisplayAd.FOOTER_CM3} />
          {isPackagePath(pageName) ? <MesoDisplayAd {...DisplayAd.FOOTER_CM4} /> : <MesoDisplayAd {...DisplayAd.FOOTER_CM6} />}
        </section>
      </div>
    </div>
  </ErrorBoundary>
);
